import { render, staticRenderFns } from "./RegexOption.vue?vue&type=template&id=a5f8217c&"
import script from "./RegexOption.vue?vue&type=script&lang=js&"
export * from "./RegexOption.vue?vue&type=script&lang=js&"
import style0 from "./RegexOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports